import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  RadioGroup,
  RadioGroupItem,
} from '@massilia/ui'
import { MailIcon, MapPin, PhoneIcon } from 'lucide-react'
import { useState } from 'react'

import { REUNION_ADDRESS, REUNION_EMAIL, REUNION_PHONE } from '@/lib/constants/agency'

import { CopiableContactField } from './copiable-contact-field'

export function RoundTripContinuityModal({
  isModalOpen,
  onSubmit,
  setIsModalOpen,
}: {
  isModalOpen: boolean
  onSubmit: () => void
  setIsModalOpen: (isModalOpen: boolean) => void
}) {
  const [isContinuityTerritorialEligibility, setIsContinuityTerritorialEligibility] =
    useState(false)

  const handleContinuityTerritorialEligibilityChange = (value: boolean) => {
    setIsContinuityTerritorialEligibility(value)
  }

  const onModalConfirm = () => {
    setIsModalOpen(false)
    onSubmit()
  }

  return (
    <Dialog onOpenChange={setIsModalOpen} open={isModalOpen}>
      <DialogContent className="gap-6 rounded-2xl bg-white p-8">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold">
            Êtes-vous éligible à la continuité territoriale, LADOM ou {'\n'} avez-vous un bon de
            ressourcement ?
          </DialogTitle>
        </DialogHeader>
        <RadioGroup
          className="flex gap-6"
          onValueChange={(value) => {
            handleContinuityTerritorialEligibilityChange(value === 'yes')
          }}
          value={isContinuityTerritorialEligibility ? 'yes' : 'no'}
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem id="no" value="no" />
            <label className="text-gray-light-700 text-sm font-medium" htmlFor="no">
              Non
            </label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem id="yes" value="yes" />
            <label className="text-gray-light-700 text-sm font-medium" htmlFor="yes">
              Oui
            </label>
          </div>
        </RadioGroup>
        {isContinuityTerritorialEligibility && (
          <div className="flex flex-col gap-6">
            <p className="text-gray-light-900 text-sm font-semibold">
              Cette aide n&apos;est pas compatible avec une réservation en ligne. Merci de contacter
              directement notre agence Massilia Voyages à La Réunion via l&apos;un des canaux
              suivants :
            </p>
            <CopiableContactField icon={PhoneIcon} label="Téléphone" value={REUNION_PHONE} />
            <CopiableContactField icon={MailIcon} label="Adresse email" value={REUNION_EMAIL} />
            <CopiableContactField icon={MapPin} label="Adresse" value={REUNION_ADDRESS} />
          </div>
        )}
        {isContinuityTerritorialEligibility ? (
          <Button
            className="bg-brand-600 hover:bg-brand-800 px-8 py-2 text-white"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>
        ) : (
          <Button
            className="bg-brand-600 hover:bg-brand-800 px-8 py-2 text-white"
            onClick={onModalConfirm}
          >
            Continuer
          </Button>
        )}
      </DialogContent>
    </Dialog>
  )
}
